import { twMerge } from 'tailwind-merge';

export interface TableHeaderProps {
  text?: string | React.ReactNode;
  sortable?: boolean;
  thClassName?: string;
  textClassName?: string;
  children?: React.ReactNode;
  onSortClick?: () => void;
}

export const TableHead = ({
  text,
  sortable,
  thClassName,
  textClassName,
  children,
  onSortClick,
}: TableHeaderProps) => {
  return (
    <th
      className={twMerge(
        '!py-[12.5px] !rounded-none !bg-purple-F7F5FF select-none [-webkit-touch-callout:none] [-webkit-user-select:none] dark-mode:!bg-coal-200',
        sortable && 'hover:cursor-pointer',
        thClassName,
      )}
      onClick={sortable ? onSortClick : undefined}
    >
      {children ? (
        <>{children}</>
      ) : (
        <div className={twMerge('', sortable && 'sort')}>
          <span
            className={twMerge(
              'sort-label text-purple-5433FF text-sm font-normal leading-4 dark-mode:text-gray-600',
              textClassName,
            )}
          >
            {text}
          </span>
          {sortable && (
            <span className="sort-icon gap-[0.5px] before:w-[5.5px] before:h-[5.5px] after:w-[5.5px] after:h-[5.5px]"></span>
          )}
        </div>
      )}
    </th>
  );
};
